<template>
  <div class="intelligent-model">
    <div class="banner">
      <div class="banner-box">
        <div class="banner-text">
          <div class="slogan animate__animated animate__fadeInLeftBig">专为科技金融打造的智能决策引擎</div>

          <div class="title animate__animated animate__fadeInLeftBig">智能评价模型</div>

          <div class="sub-title animate__animated animate__fadeInLeftBig">
            覆盖科技企业全生命周期的评价模型库，从实力评估、风险筛查到价值预判，为银行信贷全流程提供可量化、<br />
            可追溯的决策依据。<br />
          </div>

          <div class="tags-container animate__animated animate__fadeInLeftBig">
            <span v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
          </div>

          <div class="card-container animate__animated animate__fadeInLeftBig">
            <div class="card-item" v-for="(item, index) in cardList" :key="index" :style="{ backgroundImage: `url(${item.bgUrl})` }">
              <div class="card-title">
                <img :src="item.iconUrl" alt="">
                <span>{{ item.title }}</span>
              </div>
              <div class="card-desc">{{ item.desc }}</div>
            </div>
          </div>

          <div class="btn-container animate__animated animate__fadeInUp">
            <div class="exp-btn" @click="toRegister">
              <span>联系咨询</span>
              <i class="iconfont icon-youjiantou-xianxing"></i>
            </div>
          </div>
        </div>

        <div class="banner-right animate__animated animate__fadeInRightBig">
          <div v-for="(item, index) in bannerRightList" :key="index">
            <div v-if="index > 0" class="divider"></div>
            <div class="banner-right-item">
              <img :src="item.img" alt="">
              <div class="content">
                <template v-if="item.list">
                  <div v-for="(text, i) in item.list" :key="i" class="content-item">
                    <i class="iconfont icon-gouxuan-mianxing"></i>
                    <span>{{ text }}</span>
                  </div>
                </template>
                <template v-else>
                  <span v-if="item.title" class="title">{{ item.title }}</span>
                  <span v-if="item.subTitle" class="sub-title">{{ item.subTitle }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'IntelligentModel',
  computed: {
    ...mapState(['isLogin'])
  },
  data () {
    return {
      tags: ['已验证', '可定制', '全流程覆盖'],
      bannerRightList: [
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_覆盖银行信贷全流程.png',
          subTitle: '覆盖银行信贷全流程'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_实力评估.png',
          list: ['实力评估', '风险筛查', '价值预判']
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_核心评价模型.png',
          title: '4大',
          subTitle: '核心评价模型'
        }
      ],
      cardList: [
        {
          title: '科技力模型',
          desc: '五大维度 35+指标，量化企业真实科技实力',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_科技力模型.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_科技力模型.png'
        },
        {
          title: '劣汰模型',
          desc: '精准识别"伪科创"与科技属性弱的企业，把好准入关',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_劣汰模型.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_劣汰模型.png'
        },
        {
          title: '科技资质跃迁预测模型',
          desc: '预判企业下一阶段资质升级，抢先卡位优质客群',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_科技资质跃迁.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_科技资质跃迁.png'
        },
        {
          title: '专利价值评估模型',
          desc: '国家标准三维估值模型，高效量化专利价值',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_专利价值评估模型.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_专利价值评估模型.png'
        }
      ]
    }
  },
  methods: {
    toRegister () {
      this.$router.push('/register')
      window.scrollTo(0, 0, 'smooth')
    }
  }
}
</script>
<style lang='scss' scoped>
.intelligent-model {
  .banner {
    width: 100%;
    min-width: $container-width;
    height: Translate(690px);
    background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_智能评价模型.png") no-repeat;
    background-position: center center;
    background-size: cover;
    margin: 0 auto;

    &-box {
      width: $container-width;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }

    &-text {
      text-align: left;

      .slogan {
        position: absolute;
        top: Translate(58px);
        left: 0;
        @include Slogan;
      }

      .title {
        position: absolute;
        top: Translate(90px);
        left: 0;
        @include Text(60px, 500, 82px, #111, 'AlibabaPuHuiTiB');
      }

      .sub-title {
        width: Translate(680px);
        position: absolute;
        top: Translate(172px);
        left: 0;
        @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
      }

      .tags-container {
        position: absolute;
        top: Translate(234px);
        left: 0;
        display: flex;
        flex-wrap: wrap;
        gap: Translate(8px);

        span {
          @include Tag();
        }
      }

      .card-container {
        position: absolute;
        top: Translate(286px);
        left: 0;
        width: Translate(680px);
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: Translate(16px) Translate(18px);

        .card-item {
          height: Translate(116px);
          padding: Translate(20px) Translate(18px);
          background-size: 100% 100%;
          box-sizing: border-box;
          border-radius: Translate(8px);
          transition: all 0.3s ease-in;

          &:hover {
            transform: translateY(Translate(-2px));
            box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
          }

          .card-title {
            display: flex;
            align-items: center;
            gap: Translate(6px);
            @include Text(18px, 600, 24px, #111111, 'PingFangSC-Semibold');

            img {
              width: Translate(18px);
              height: Translate(18px);
            }
          }

          .card-desc {
            margin-top: Translate(4px);
            @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
          }
        }
      }

      .btn-container {
        position: absolute;
        top: Translate(574px);
        left: 0;
        display: flex;
        justify-content: space-between;

        .exp-btn {
          @include Button(180px, 60px, transparent, 16px, #fff);
          background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
          border-radius: Translate(30px);
          transition: all 0.15s ease-in;

          &:hover {
            opacity: 0.8;
            transform: translateY(Translate(-4px));
            box-shadow: 4px 10px 30px -4px rgba(0, 88, 255, 0.4);
          }

          i {
            font-size: Translate(22px);
            margin-left: Translate(6px);
            transition: transform 0.15s ease-in;
            @include ChevronIconAnimation();
          }
        }
      }
    }

    &-right {
      position: absolute;
      top: Translate(190px);
      right: 0;
      display: flex;
      flex-direction: column;

      &-item {
        display: flex;
        align-items: center;
        gap: Translate(20px);

        img {
          height: Translate(60px);
        }

        .content {
          display: flex;
          flex-direction: column;
          align-items: start;

          .title {
            @include Text(50px, 600, 50px, #111, 'PingFangSC-Semibold');
            @include GradientText();
          }

          .sub-title {
            margin-top: Translate(8px);
            @include Text(18px, 400, 24px, #111111, 'PingFangSC-Regular');
          }

          .content-item {
            display: flex;
            align-items: center;
            gap: Translate(6px);
            @include Text(18px, 400, 34px, #111111, 'PingFangSC-Regular');

            i {
              font-size: Translate(16px);
              color: #65A5F9;
            }
          }
        }
      }

      .divider {
        height: Translate(1px);
        background: #FFFFFF;
        margin: Translate(28px) 0;
      }
    }
  }
}

#img-container {
  width: Translate(130px);
  height: Translate(130px);
  margin-left: Translate(10px);
  display: flex;
  justify-content: center;
  align-items: center;
}

#code {
  text-align: center;
  font-size: Translate(12px);
  color: #333333;
  font-weight: 400;
  padding-bottom: 15px;
}
</style>
